export const paymentsTypes = ["card", "cash", "online", "free", "zaps", "thriwe"];

export const statusTypes = [
  {
    label: "Open",
    value: "open",
  },
  {
    label: "Requested",
    value: "requested",
  },
  {
    label: "Closed",
    value: "closed",
  },
  {
    label: "No Show",
    value: "noshow",
  },
  {
    label: "Drop Off",
    value: "dropoff",
  },
];
